import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import i18n from 'i18n';
import { capitalize } from 'lodash';
import { useTranslation } from 'react-i18next';

import * as datetime from 'legacy/common/utils/datetime';

const EventDate = ({ startDate, endDate, activeStatus }) => {
  const { t } = useTranslation(['events']);
  const formattedStartDate = capitalize(
    new Date(startDate).toLocaleDateString(i18n.language, {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  );

  const formattedStartTime = new Date(startDate).toLocaleTimeString(
    i18n.language,
    {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }
  );

  const isStartEndSameDate = endDate
    ? datetime.isSame(startDate, endDate, 'day')
    : true;

  const formattedEndDate =
    endDate &&
    new Date(endDate).toLocaleDateString(i18n.language, {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

  const formattedEndTime =
    endDate &&
    new Date(endDate).toLocaleTimeString(i18n.language, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

  if (activeStatus === 'past') {
    return (
      <p className="pt-[4px] text-lg text-gray-500 flex items-center">
        <FaCheckCircle className="mr-2" />
        {t('events:eventDetails.eventHasPassed')}
      </p>
    );
  }

  if (isStartEndSameDate) {
    return (
      <div className="pt-[4px] text-xl text-gray-600 font-normal">
        {`${formattedStartDate} • ${formattedStartTime}`}
        {formattedEndTime && ` - ${formattedEndTime}`}
      </div>
    );
  }

  return (
    <div className="pt-[4px] flex flex-col gap-2 text-gray-600">
      <div>
        <p className="text-base">{t('events:eventDetails.starts')}</p>
        <div className="text-xl text-gray-600 font-normal">
          {formattedStartDate} • {formattedStartTime}
        </div>
      </div>
      <div>
        <p className="text-base">{t('events:eventDetails.ends')}</p>
        <div className="text-xl text-gray-600 font-normal">
          {formattedEndDate} • {formattedEndTime}
        </div>
      </div>
    </div>
  );
};

export default EventDate;
